import Annotate from './annotate/component.vue'

export default {
  Annotate
}